export default (state = { data: [], error: false, loading: false, defaultResponse: true }, action) => {

    switch (action.type) {

        case 'CREATE_NEW_RELEASE_REQUEST':
            return {
                data: [],
                loading: true,
                error: false,
                defaultResponse: true
            };

        case 'CREATE_NEW_RELEASE_SUCCESS':
            return {
                data: action.payload.data,
                responseDefault: false,
                loading: false,
                success: true,
                error: false,
                message: action.payload['message'],
            };

        case 'CREATE_NEW_RELEASE_FAILURE':
            return {
                data: [],
                error: true,
                responseDefault: false,
                loading: false,
                success: false,
                message: action.payload.response.data['message'],
            };

        default:

            return state;

    }

};